import { z } from "zod";
import { zGuard } from "../zod/utils.js";

import { EnumValues, McpServerConfigurationType } from "../enums";
import { getNormalEnum } from "../pseudoEnums";

export const SupportedMcpServerLiteral = z.enum(["Notion", "Linear"]);
export const SupportedMcpServer = getNormalEnum(SupportedMcpServerLiteral);
export type SupportedMcpServer = EnumValues<typeof SupportedMcpServer>;

export type SupportedMcpServerDetails = {
  name: SupportedMcpServer;
  description: string;
  url: string;
};

export const SupportedMcpServerDetails: SupportedMcpServerDetails[] = [
  {
    name: SupportedMcpServer.Notion,
    description:
      "Connect Notion to the Hex Agent to create, edit, and search Notion documents.",
    url: "https://mcp.notion.com/mcp",
  },
  {
    name: SupportedMcpServer.Linear,
    description:
      "Connect Linear to the Hex Agent to find, create, and update Linear issues, projects, and comments.",
    url: "https://mcp.linear.app/mcp",
  },
];

export const isValidSupportedMcpServer = (
  type: McpServerConfigurationType,
  name: string,
): boolean => {
  if (type === McpServerConfigurationType.PRE_DEFINED) {
    return zGuard(SupportedMcpServerLiteral, name);
  }
  return true;
};
